import axios from 'axios';

import type { FileDoc } from '@bb/domain/dist/schemas';
import type { BuildJsonType } from '@bb/domain/dist/typeHelpers';

export type GetListingFilesResponse = BuildJsonType<
  (FileDoc & { isPhoto: boolean; isAttachment: boolean })[]
>;

const GetListingFiles = async (id: string, type: string) => {
  const { data } = await axios.get<GetListingFilesResponse>(
    `/${type}/${id}/file`,
  );
  return data;
};

export default GetListingFiles;
